import React from 'react';
//import './SponsoredPage.css';
//import Sponsore from './Sponsore/Sponsore';
import Nav from '../SponsoredPage/inc/Nav/SponsoredNav';
import Footer from '../LandingPage/inc/Footer/Footer';
import Terms from './Terms/Terms';

const SponsoredPage: React.FC = () => {
    return (
        <div>
            <Nav />
            <Terms title=" TERMS OF USE" />
            <Footer />
        </div>
    );
};

export default SponsoredPage;